/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type ActivityCategory = typeof ActivityCategory[keyof typeof ActivityCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityCategory = {
  ActivityCategoryBillable: 'billable',
  ActivityCategoryNonBillable: 'non_billable',
  ActivityCategoryPto: 'pto',
} as const;
